export const RESPONSE_CODE = {
  unauthorized: 'server-error.10001',
  forbidden: 'server-error.10002',
  bad_request: 'server-error.10004',
  server_error: 'server-error.10000',
};

export const AUTH_STORAGE = 'authStore';
export const AUTH_REMEMBER_ME = 'remember_me';
